import React from 'react';
import { Link } from 'react-router-dom';
import { useObservable } from 'react-use-observable';

import { Badge, List, Typography } from 'antd';

import { ENotificationType } from 'v2/interfaces/notification';
import notificationService from 'v2/services/notifications';

export default function ProductReproved() {
  const [notifications] = useObservable(() => notificationService.getListGroupNotifications(), []);

  const products = (notifications || []).find(n => n.type === ENotificationType.DISAPPROVED_PRODUCT);
  if (!products?.quantity) return null;

  return (
    <Link to={`/producer/notifications/${ENotificationType.DISAPPROVED_PRODUCT}`}>
      <List.Item extra={<Badge count={products?.quantity || 0} showZero />}>
        <Typography.Text strong>Produtos Reprovados</Typography.Text>
      </List.Item>
    </Link>
  );
}
